// Ba thẻ của người đứng thu tiền: "Cần thu", "Phiếu chờ khách chuyển", "Đã thu".
//
// Nhãn thẻ lấy từ từ điển nhãn của màn, không gõ chuỗi lần hai — xem
// `../../payment-guide-tabs.ts`.

import { TAB_LABEL } from "@/features/payments/labels";
import type { GuideTab } from "../../types";

export const TABS_THU_TIEN: GuideTab[] = [
  {
    key: "due",
    label: TAB_LABEL.due,
    purpose: "Danh sách đơn còn thiếu tiền, và chỗ bấm để thu nốt.",
    where: [
      'Ô tìm đầu thẻ nhận mã đơn, tên khách hoặc số điện thoại.',
      'Cạnh ô tìm: ô tích "Ẩn đơn đã đủ" — bỏ tích để thấy cả đơn đã trả xong.',
      'Hai nút gộp thành một cặp: "Mọi đơn còn nợ" và "Đơn đang treo phiếu" — số trong ngoặc ở nút thứ hai là đếm thật trên toàn bộ đơn, không phải đếm trong trang đang xem.',
      'Bảng có sáu cột tiền: Tổng · Cọc · Đã thu · Chờ · Còn lại, đơn nợ nhiều nhất xếp trên cùng.',
      'Cuối mỗi dòng: nút "💰 Thu", và nút "Hủy chờ" chỉ hiện khi đơn đó đang treo một phiếu chưa xong.',
      'Ở "Đơn đang treo phiếu", đơn dự bị, giữ chỗ tạm hoặc đã huỷ mang thêm nhãn trạng thái nhỏ cạnh tên khách.',
      'Dòng chữ nhỏ dưới hàng chip ngày nói thẻ này lọc theo ngày nào: "Đơn đang treo phiếu" lọc theo ngày lập phiếu chờ, "Mọi đơn còn nợ" lọc theo ngày tạo đơn — không thẻ con nào lọc theo ngày chụp.',
    ],
    howItWorks: [
      'Cột "Còn lại" trừ tiền người thu đã nhận mà chưa được xác nhận, nên một đơn vừa ghi phiếu đủ tiền cũng về không — lúc đó cột hiện chữ "Chờ xác nhận" chứ không phải "Đủ". Hai chữ đó khác nhau: một bên tiền đã về thật, một bên chưa ai xác nhận.',
      'Mã QR đã gửi mà khách CHƯA chuyển thì cột "Còn lại" KHÔNG trừ: chưa có đồng nào, nên khoản đó vẫn là nợ. Cột "Chờ" vẫn hiện số của mã đó để người thu biết đơn đang có mã ngoài kia.',
      'Nút "💰 Thu" mờ đi có đúng hai lý do — đơn đã trả xong, hoặc đơn đang vướng một phiếu treo. Rê chuột vào nút để đọc lý do của chính dòng đó.',
      'Vướng phiếu treo mà cần lập phiếu mới thì bấm "Hủy chờ" trước; huỷ phiếu treo không làm mất tiền đã thu trước đó.',
      'Mã QR khách tự mở trên Cổng mà chưa chuyển tiền KHÔNG khoá nút "💰 Thu": lúc bạn lưu phiếu thu, máy tự đóng mã đó (lý do ghi "nhân viên đã thu tại quầy") và số còn thiếu điền sẵn đã gồm cả phần mã đó đang giữ. Mã Cổng đã có tiền chuyển về thì vẫn giữ chỗ như phiếu treo thường.',
      'Nút "Đơn đang treo phiếu" hỏi thẳng máy chủ nên gom đủ đơn treo ở mọi trang; ô tích "Ẩn đơn đã đủ" bị khoá lúc đó, vì thẻ này cố ý hiện cả đơn đã đủ tiền mà còn treo phiếu.',
      '"Đơn đang treo phiếu" gom MỌI đơn còn phiếu chưa xong, kể cả đơn dự bị, giữ chỗ tạm, đã huỷ và đơn đã giao đủ tiền — những đơn không nằm ở "Mọi đơn còn nợ". Nhờ vậy phiếu treo của chúng vẫn có chỗ bấm "Hủy chờ".',
      'Đơn đã huỷ thì nút "💰 Thu" bị khoá: không thu thêm cho đơn huỷ, dòng của nó ở đây chỉ để gỡ phiếu còn treo.',
      'Khoảng ngày ở đầu trang chọn theo ngày LẬP PHIẾU CHỜ khi đang ở "Đơn đang treo phiếu", và theo ngày TẠO ĐƠN khi đang ở "Mọi đơn còn nợ". Vì vậy phiếu cọc lập hôm nay luôn nằm trong "Tháng này", dù lịch chụp rơi vào tháng sau.',
      'Cột "Đã thu" là tiền khách đã trả vào, chưa trừ khoản đã hoàn lại khách — nên đơn đủ tiền rồi được hoàn một phần vẫn hiện "Đủ", không quay lại thành nợ.',
      'Đơn đã giao khách mà khách còn nợ VẪN nằm trong thẻ này cho tới khi thu đủ — giao ảnh xong không xoá khoản nợ. Đơn đã giao và đã trả đủ thì rời thẻ.',
    ],
    statuses: [
      { label: "Đủ", meaning: 'Cột "Còn lại": đơn hết nợ, tiền đã về thật.' },
      {
        label: "Chờ xác nhận",
        meaning:
          'Cột "Còn lại": người thu đã ghi nhận đủ tiền nhưng chưa được xác nhận, nên chưa tính là đã thu.',
      },
      {
        label: "Chờ thanh toán",
        meaning: "Nhãn nhỏ cạnh tên khách: đơn này đang treo ít nhất một phiếu chưa xong.",
      },
      {
        label: "Dự bị / Giữ chỗ tạm / Huỷ",
        meaning:
          'Nhãn nhỏ cạnh tên khách, chỉ gặp ở "Đơn đang treo phiếu": đơn chưa chốt hoặc đã huỷ nhưng còn phiếu treo.',
      },
    ],
    blocks: [
      {
        for: ["reception", "sale"],
        title: "Thu nốt tiền của một đơn",
        steps: [
          "Gõ số điện thoại hoặc tên khách vào ô tìm để ra đúng đơn.",
          'Nhìn cột "Còn lại" xem đơn còn thiếu bao nhiêu.',
          'Bấm "💰 Thu" ở cuối dòng — hộp thu tiền mở ra với ba tình huống: khách quét mã, khách đưa tiền mặt, khách báo đã chuyển rồi.',
          "Số tiền trong hộp điền sẵn phần còn thiếu; khách trả ít hơn thì sửa lại trước khi lưu.",
          'Đơn khách đã hẹn trả sau: cứ để nguyên, đừng huỷ phiếu treo của người khác.',
          'Khách vừa mở mã trên Cổng rồi ra quầy trả: cứ thu bình thường, không cần huỷ mã đó trước — lưu phiếu xong máy tự đóng mã của khách.',
        ],
        troubles: [
          'Nút "💰 Thu" mờ: rê chuột vào nút đọc lý do — đã đủ tiền thì thôi, còn vướng phiếu treo thì bấm "Hủy chờ" rồi lập lại.',
          'Tìm không ra đơn: "Mọi đơn còn nợ" chỉ gom đơn đang chạy và đơn đã giao còn nợ. Đơn dự bị, đơn đã huỷ, hay đơn tạo từ tháng trước mà mới lập phiếu hôm nay thì bấm "Đơn đang treo phiếu" để tìm; không thì nới khoảng ngày ở đầu trang ra rồi tìm lại.',
          'Cần gỡ phiếu treo của đơn dự bị hoặc đơn đã huỷ: bấm "Đơn đang treo phiếu", tìm đơn, rồi bấm "Hủy chờ" ở cuối dòng.',
          'Đơn đã thu tiền mà vẫn nằm trong danh sách: bỏ tích "Ẩn đơn đã đủ" xem lại cột "Chờ" — thường là còn một phiếu treo chưa được xác nhận.',
          "Máy báo đơn chưa có số phải thu: đơn chưa có giá nên chưa nhận phiếu thu — sửa giá đơn hoặc thêm khoản khách mua rồi thu lại.",
        ],
      },
      {
        for: ["accounting"],
        title: "Soát công nợ trên thẻ này",
        steps: [
          'Bấm "Đơn đang treo phiếu" để tách riêng đơn đang treo phiếu — đó là phần tiền đã lập phiếu mà chưa vào sổ.',
          'Đọc cột "Chờ" và cột "Còn lại" cùng lúc: cột Chờ gồm cả mã QR khách chưa quét, còn cột Còn lại chỉ trừ tiền đã ghi nhận đang chờ xác nhận — hai cột nói hai chuyện khác nhau.',
          'Đơn hiện chữ "Chờ xác nhận" ở cột Còn lại là đơn đã ghi nhận đủ tiền nhưng CHƯA được xác nhận, dù nhìn như đã đủ tiền.',
          "Muốn xem cả đơn đã trả xong thì bỏ tích Ẩn đơn đã đủ.",
        ],
        troubles: [
          "Con số ở thẻ này lệch với sổ đã thu: thẻ này lọc theo ngày tạo đơn hoặc ngày lập phiếu chờ, sổ đã thu lọc theo ngày ghi nhận tiền — các mốc ngày khác nhau.",
        ],
      },
      {
        for: ["lead", "exec"],
        title: "Nhìn nhanh phần còn phải thu",
        steps: [
          'Bấm ô "TỔNG CÔNG NỢ" ở đầu trang là nhảy thẳng vào thẻ này.',
          'Bấm "Đơn đang treo phiếu" để tách riêng những đơn đang treo phiếu — đây là chỗ tiền dễ đứng lại lâu nhất.',
          "Đọc cột Chờ và cột Còn lại cùng lúc: hai cột đó nói hai chuyện khác nhau.",
        ],
      },
    ],
  },

  {
    key: "waiting",
    label: TAB_LABEL.waiting,
    purpose: "Các phiếu đã phát mã cho khách nhưng tiền chưa về tài khoản.",
    where: [
      "Ô tìm nhận mã đơn, tên khách hoặc ghi chú.",
      "Bảng có cột Khách hàng · Số tiền · Người thu · Ghi chú · Thời gian.",
      'Cuối dòng có nút "Xem QR" để mở lại mã đã phát cho khách.',
      'Phiếu chuyển khoản bạn lập có thêm nút "🧾 Đính bill" (đã có bill thì là "🧾 Thay bill"); phiếu đã có bill hiện "🧾 Xem bill" ở cột Ghi chú.',
      'Dòng chữ nhỏ dưới hàng chip ngày ghi "Lọc theo ngày tạo mã". Thẻ này mở ra là chọn sẵn "Tất cả", để mã phát từ tháng trước không bị giấu.',
      "Số trong ngoặc trên tên thẻ là số phiếu đang chờ.",
    ],
    howItWorks: [
      "Phiếu vào đây ngay khi có người phát mã, và tự rời đi khi tiền về khớp được với phiếu — không ai phải bấm gì để nó biến mất.",
      "Mã quét tại quầy chỉ sống mươi lăm phút rồi tự huỷ phiếu; mã gửi khách sống tới khi khách trả xong, đơn bị huỷ, hoặc có người lập mã trả nốt toàn bộ số nợ của đơn — lúc đó mã cũ tự đóng, vì giữ cả hai là khách trả dư. Khách lỡ chuyển theo mã cũ vừa bị thay, đúng số trên mã, thì máy vẫn tự nhận vào phiếu của mã mới; lệch số mới sang hàng chờ kế toán. Vì vậy phiếu treo lâu ở đây gần như luôn là loại gửi khách.",
      'Mã ở thẻ này chưa phải tiền: cột "Còn lại" ở thẻ "Cần thu" không trừ nó, và mã trả nốt lập sau sẽ đòi đủ cả phần của nó.',
      'Mở lại "Xem QR" cho đúng phiếu cũ thay vì lập phiếu mới: hai phiếu cùng một khoản tiền là hai lần chờ, và khách hay chuyển theo mã đã chụp màn hình từ trước.',
      'Khách chuyển mà gõ sai nội dung thì tiền không tự khớp được với phiếu: chụp bill khách gửi rồi bấm "🧾 Đính bill" ngay trên dòng phiếu — bill nằm luôn trên phiếu để đối chiếu khi xác nhận, không phải lập phiếu mới.',
    ],
    statuses: [
      {
        label: "Đang chờ khách chuyển",
        meaning: "Mã đã phát, tiền chưa về. Phiếu tự rời thẻ này khi tiền về khớp.",
      },
    ],
    blocks: [
      {
        for: ["reception", "sale"],
        title: "Theo dõi phiếu mình đã phát mã",
        steps: [
          'Tìm theo tên khách để xem phiếu mình lập còn treo không.',
          'Khách gọi báo đã chuyển mà phiếu vẫn treo: mở hộp thu tiền của đơn đó, sang thẻ "Tiền về chưa?" để dò khoản vừa về.',
          'Khách làm mất mã: bấm "Xem QR" mở lại đúng mã cũ rồi gửi lại, đừng lập phiếu thứ hai.',
          'Khách báo đã chuyển nhưng gõ sai nội dung: xin khách ảnh bill, bấm "🧾 Đính bill" trên dòng phiếu đó rồi chọn ảnh.',
        ],
        troubles: [
          "Phiếu treo cả ngày: gọi khách hỏi lại — mã gửi khách không tự hết hạn nên nó nằm đó tới khi có người xử.",
          'Không thấy nút "🧾 Đính bill": nút chỉ có trên phiếu chuyển khoản do chính bạn lập — phiếu người khác lập thì nhờ người đó hoặc kế toán đính.',
          'Đính nhầm ảnh: bấm "🧾 Thay bill" trên cùng dòng và chọn lại ảnh đúng.',
          "Khách đã chuyển nhưng phiếu chưa rời: tiền về chậm hơn tin nhắn ngân hàng của khách, đợi một lát rồi tải lại trang.",
        ],
      },
      {
        for: ["accounting"],
        title: "Đọc hàng phiếu đang treo",
        steps: [
          "Đọc cột Thời gian để thấy phiếu nào treo lâu bất thường.",
          'Phiếu treo lâu thường là mã gửi khách — đối chiếu với thẻ "Tiền về chưa rõ đơn" xem tiền đã về mà chưa ghép được không.',
        ],
      },
      {
        for: ["lead", "exec"],
        title: "Nhìn nhanh tiền đang trên đường",
        steps: [
          'Bấm ô "ĐANG CHỜ KHÁCH CHUYỂN" ở đầu trang là vào thẳng thẻ này.',
          "Số phiếu treo tăng dần qua nhiều ngày là dấu hiệu khâu nhắc khách đang chậm.",
        ],
      },
    ],
  },

  {
    key: "collected",
    label: TAB_LABEL.collected,
    purpose: "Sổ các khoản đã thu xong, để tra lại một lần trả tiền cụ thể.",
    where: [
      "Ô tìm nhận mã đơn, tên khách, ghi chú hoặc một đoạn nội dung chuyển khoản.",
      "Ba ô lọc cạnh nhau: cách trả tiền (Tiền mặt, Chuyển khoản, Thẻ, Momo, ZaloPay), Loại phiếu, và Thương hiệu.",
      'Ô "Loại phiếu" có bốn lựa chọn: Cọc · Một phần · Đủ · Hoàn.',
      "Cuối hàng lọc: số giao dịch tìm được và tổng tiền của riêng trang đang xem.",
      'Dòng chữ nhỏ dưới hàng chip ngày ghi "Lọc theo ngày ghi nhận thanh toán".',
      'Cột "Nội dung CK" nằm ngay trước cột "Ghi chú", chép nguyên dòng nội dung khách gõ khi chuyển khoản; dòng dài bị cắt, rê chuột vào để đọc đủ.',
    ],
    howItWorks: [
      "Chỉ khoản đã thu xong mới vào đây; phiếu còn treo nằm ở thẻ khác, nên số ở thẻ này là tiền đã thật sự về.",
      'Ô "Thương hiệu" lọc theo thương hiệu của ĐƠN, không phải thương hiệu ghi trên phiếu — hai thứ đó có thể khác nhau.',
      "Tổng tiền cuối hàng lọc chỉ cộng trang đang xem, không cộng cả kỳ; đổi trang là số đó đổi theo.",
      "Khoản hoàn trả cho khách cũng nằm trong sổ này, tìm bằng cách chọn Loại phiếu là Hoàn.",
      'Cột "Nội dung CK" chỉ có chữ ở khoản chuyển khoản; khoản tiền mặt để trống ô này.',
    ],
    statuses: [
      { label: "Cọc", meaning: "Khoản khách đặt trước khi chụp." },
      { label: "Một phần", meaning: "Khách trả thêm một phần, đơn vẫn còn thiếu." },
      { label: "Đủ", meaning: "Khoản trả nốt, đơn hết nợ." },
      { label: "Hoàn", meaning: "Tiền trả lại khách, ghi số âm." },
    ],
    blocks: [
      {
        for: ["reception", "sale"],
        title: "Tra lại một lần khách đã trả",
        steps: [
          "Gõ tên khách hoặc mã đơn vào ô tìm.",
          "Khách hỏi đã cọc bao nhiêu: chọn Loại phiếu là Cọc rồi đọc cột Số tiền.",
          "Nới khoảng ngày ở đầu trang nếu khoản cần tra đã lâu — thẻ này lọc theo ngày ghi nhận.",
          'Khách nói đã chuyển khoản: đọc cột "Nội dung CK" để thấy khách đã gõ gì lúc chuyển.',
        ],
        troubles: [
          "Không thấy khoản vừa thu: khoản chưa được xác nhận thì chưa vào sổ này, nó còn nằm ở hàng chờ.",
        ],
      },
      {
        for: ["accounting"],
        title: "Soát lại tiền đã thu trong kỳ",
        steps: [
          "Chọn khoảng ngày ở đầu trang, rồi lọc theo cách trả tiền để tách tiền mặt khỏi chuyển khoản.",
          "Chọn Loại phiếu là Hoàn để rà riêng các khoản đã trả lại khách.",
          "Cột Người thu cho biết khoản đó do ai ghi nhận.",
        ],
      },
      {
        for: ["lead", "exec"],
        title: "Xem tiền về trong kỳ",
        steps: [
          'Bấm ô "ĐÃ THU HÔM NAY" ở đầu trang để vào thẳng thẻ này.',
          "Đổi khoảng ngày ở đầu trang để xem kỳ khác.",
          "Lọc theo thương hiệu khi cần tách doanh thu từng thương hiệu.",
        ],
      },
    ],
  },
];
